export const V1_REQUEST_FILTERED_TOUR_OPERATORS =
  'V1_REQUEST_FILTERED_TOUR_OPERATORS'

export default data => {
  return {
    type: V1_REQUEST_FILTERED_TOUR_OPERATORS,
    data,
  }
}
